/**
 * The product-image upload profile — the client-side mirror of the runtime's
 * `IMAGE_MAX_BYTES` (`inventory/services/images.service.ts`).
 *
 * Modelled on `videoProfile.ts`. Every product-media surface — item gallery,
 * hero, storefront banners, category and collection images — validates against
 * this and renders its copy from it. Before, five components each declared their
 * own `MAX_BYTES` and spelled "10 MB" into nine strings, so raising the limit
 * meant finding all fourteen and any one missed would reject a file the server
 * would happily have taken (or promise a size it would refuse).
 *
 * Keep in step with the backend constant: the server is the real gate, this is
 * only so the user hears "too big" instantly instead of after the upload.
 */
export const IMAGE_MAX_BYTES = 15 * 1024 * 1024;

/** Human label for the limit, e.g. "15 MB" — for hints and error copy. */
export const IMAGE_MAX_LABEL = `${IMAGE_MAX_BYTES / 1024 / 1024} MB`;

/** Standard over-size message, so every surface says the same thing. */
export function imageTooLargeMessage(name?: string): string {
  const subject = name ? `${name} is` : 'That image is';
  return `${subject} over ${IMAGE_MAX_LABEL}. Compress or resize it and try again.`;
}
